import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Parâmetro Transporte',
    path: '/transporte/traparametro',
    name: 'traparametro',
    component: () => import('@/views/transporte/traparametro/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.PARAMETROSTRANSPORTENOVO_MENU_1100400199],
    },
    goesToMenu: true,
  },
];
